import API from 'services/TAPS_API';

export default function refusal(data) {
  return API.request({
    method: 'POST',
    url: '/refusal',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function refusalPdf() {
  return API.request({
    method: 'GET',
    url: '/refusal/pdf',
  });
}
